import React, { useState, useEffect } from "react";
import { Row, Col, Form, Switch, Checkbox, Spin, Button, message } from "antd";
import { connect } from "react-redux";
import { getClientid, getLocations } from "redux/selectors";
import { CALL_API } from "common/API";
import { STATUS_CODE, VALIDATE_CHARACTER, VALIDATE_SYMBOL_CHARACTER } from "common/Constants";
import { getMySqlDate } from "utils/Date";
import EditInformation from "molecules/EditInformation";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FormModal from "./FormModal";
import styled from "styled-components";
import { LoadingOutlined } from '@ant-design/icons';

const StyledButton = styled(Button)`
  background-color: #00685F;
  border-radius: 5px;
  color: #FFFFFF !important;
  width: 100px;
  ${'' /* font-weight: bold; */}
  &:hover {   background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
`;
const EditHoliday = ({
  isModalVisible,
  closeModal,
  ClientId,
  getHolidayList,
  HolidayDetails,
  locationList,
  // Note : need for delete
  deleteHoliday,
  viewOnly
}) => {
  const [form] = Form.useForm();

  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [values, setValues] = useState({});
  const [submit, setsubmit] = useState(false);
  const [create, setCreate] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);

  useEffect(() => {
    setValues({
      name: HolidayDetails?.holiday_name ?? "",
      start_date: HolidayDetails?.start_date ?? null, // keep string
      end_date: HolidayDetails?.end_date ?? null,     // keep string
    });
    setSelectedLocationId(Array.isArray(HolidayDetails?.location_id) ? HolidayDetails.location_id : []);
  }, [HolidayDetails]);

  useEffect(() => {
    form.setFieldsValue({
      Holiday_name: HolidayDetails.HolidayName,
      description: HolidayDetails.description,
    });

    setSelectAllLocationChecked(
      selectedLocationId.length === locationList.length
    );
  }, [HolidayDetails, selectedLocationId, locationList]);

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "country",
      key: "country",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            disabled={viewOnly}
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
    setsubmit(true);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e.target.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = locationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
    setsubmit(true);
  };

  // useEffect(() => {
  //   if (submit) {
  //     handleSubmit();
  //   }
  // }, [selectedLocationId, values]);

  const handleSubmit = async () => {
    try {
      setCreate(true);
      const start = values?.start_date ?? HolidayDetails?.start_date ?? null;
      const end   = values?.end_date   ?? HolidayDetails?.end_date   ?? null;
      if (!values?.name || !start || !end) {
        setCreate(false);
        message.error("Holiday name and dates are required.");
        return;
      }
      const payload = {
        holidayname: values.name?.trim(),
        color: "#EB4747",
        startdate: getMySqlDate(start),
        enddate: getMySqlDate(end),
        locationid: selectedLocationId,
      };
      const { code } = await CALL_API(
        `holiday/${ClientId}/${HolidayDetails.holiday_id}`,
        "patch",
        payload
      );
      if (code === STATUS_CODE.SUCCESS) {
        message.success("Holiday has been updated successfully");
        getHolidayList();
      }
    } finally {
      setCreate(false);
    }
  };
  const handleSave = async () => {
    await handleSubmit(); 
    closeModal();
  };

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <>
          {viewOnly ? (
            <Row className="styled-card">
              <Col>
                <b>Location Name</b> : {values.name}
              </Col>
            </Row>
          ) : (
            <EditInformation
              details={HolidayDetails}
              setValues={setValues}
              setsubmit={setsubmit}
              title="holiday"
            />
          )}
        </>
      ),
    },
    {
      id: 2,
      label: "Country",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {locationList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllLocationChecked}
                  onChange={handleSelectAllLocationChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}

          <EditSelectTable
            columns={locatincolumns}
            tabledata={locationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      ),
    },
  ];

  return (
    <>
      {isModalVisible && (
        <>
        <HolidayStyle>
          <div className="d-flex justify-content-between">
            <div className="holiday_header_content">
              <label
                className="bg-transparent border-0 mb-3 text-left styled-cursor"
                onClick={() => {
                  closeModal(false);
                }}
              >
                Holiday <ArrowForwardIosIcon className="px-1" />
              </label>{" "}
              <b className=" pb-0 pt-1">{values.name}</b>
            </div>
            <div className="holiday_header_action">
              <StyledButton onClick={handleSave}>{create && <Spin indicator={<LoadingOutlined spin />} />}Save</StyledButton>
            </div>
          </div>
        </HolidayStyle>
        <TabsList items={items} />
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
});
export default connect(mapStateToProps)(EditHoliday);

const HolidayStyle = styled.div`
  .holiday_header_content{
    width: max-content;
  }
  .holiday_header_action{
    width: 20px;
    height: 20px;
    width: max-content;
  }
`;